<div class="vditor-field"
  [class.vditor-field--pinned]="toolbarPinned"
  [class.vditor-field--readonly]="readonly || disabled">
  <div class="vditor-field__label" *ngIf="showLabel && label">{{ label }}</div>
  <div #vditorHost class="vditor-field__host" [attr.aria-label]="label || placeholder"></div>
  <div class="vditor-field__error" role="alert" *ngIf="initializationError">
    Markdown表示を初期化できませんでした。
  </div>
</div>
